<template>
  <div class="chat-box">
    <div class="chat-box-header">
      <div class="left">{{ groupInfo.name ? groupInfo.name + " (" + groupInfo.user_num + "/" + groupInfo.limit_num + ")" : "" }}</div>
      <img @click.stop="setting()" src="./img/setting.png" alt="" class="right" />
    </div>
    <div class="private-content" ref="privateChat" @scroll="onscroll" @click="closeDeleteMsgPopup">
      <img v-show="isLoadingMore" src="@/assets/img/loading-1.gif" alt="" style="display: block; margin: 0 auto" />
      <div :style="{ height: addHeightForBanned }"></div>
      <div class="message-list" v-for="(item, index) in groupMessageList" :key="index" ref="avatar">
        <div class="chat-time" v-show="item.chatType === 3">{{ item.content }}</div>
        <div class="chat-anchor" v-show="item.chatType === 2 && (item.content || item.image_url) && item.type !== 2">
          <div class="avatar">
            <img @click.stop="openBannedUserPopup(item, index)" :src="item.avatar ? item.avatar : require('@/assets/img/default/default_logo1.png')" alt="" />
            <div class="popup-banned" v-show="bannedUser === item.send_time">
              <div class="banned" @click.stop="toUserChat(item)">私聊</div>
              <div class="bar"></div>
              <div class="banned" @click.stop="openConfirmBannedPopup(item)">禁言</div>
              <div class="bar"></div>
              <div class="banned" @click.stop="openConfirmKickoutPopup(kickoutDialog)">踢出群聊</div>
            </div>
            <div class="popup-banned" v-show="unbannedUser === item.send_time">
              <div class="banned" @click.stop="openConfirmUnbannedPopup(unbannedDialog)">解除禁言</div>
              <div class="bar"></div>
              <div class="banned" @click.stop="openConfirmKickoutPopup(kickoutDialog)">踢出群聊</div>
            </div>
          </div>
          <div class="msg" @click.stop="openDeleteMsgPopup(index)">
            <div class="popup" @click.stop="openConfirmDeleteMsgPopup(deleteMsgDialog, item)" v-show="deleteMsgId === index">删除</div>
            <img class="angle" src="./img/angle-left.png" alt="" />
            <div class="nickname">
              <div>{{ item.nick_name }}</div>
              <div class="role" v-show="item.role === 1">房管</div>
              <div class="role role1" v-show="item.role === 2">群主</div>
            </div>
            <div class="text">{{ item.content }}</div>
            <el-image v-show="item.image_url" :src="item.image_url" @load="loadImage" :preview-src-list="[item.image_url]"> </el-image>
          </div>
        </div>
        <div class="chat-user" v-show="item.chatType === 1 && (item.content || item.image_url) && item.type !== 2">
          <div class="msg" @click.stop="openWithdraw(index)">
            <div class="withdraw" @click.stop="openConfirmWithdrawPopup(withdrawDialog, item)" v-show="withdrawMsgId === index">撤回</div>
            <div class="red-dot" v-show="errorMessageIds.indexOf(item.send_time) > -1" @click="showErrorMsg">!</div>
            <img class="angle" src="./img/angle-right.png" alt="" />
            <div class="text">{{ item.content }}</div>
            <el-image v-show="item.image_url" :src="item.image_url" @load="loadImage" :preview-src-list="[item.image_url]"> </el-image>
          </div>
          <img class="avatar" :src="userInfo.avatar ? userInfo.avatar : require('@/assets/img/default/default_logo1.png')" alt="" />
        </div>
      </div>
    </div>
    <div class="to_bottom_btn" @click="toBottom" v-if="showMoreMsg">底部有新的消息</div>
    <div class="chat-box-message">
      <textarea placeholder="在这里输入内容..." name="" id="" rows="4" v-model="messageContent" @input="formatMessage" @keyup.ctrl.enter="lineFeed()" @keyup.enter.exact="sendMsg()"></textarea>
      <div class="bottom">
        <div class="plugs">
          <emoji-picker @emoji="insert">
            <div slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
              <img class="icon-img" src="./img/emoji.png" title="表情" />
            </div>
            <div class="emoji" slot="emoji-picker" slot-scope="{ emojis, insert }">
              <div class="emoji-cats">
                <div class="emoji-cat" :class="emojiCategory == index ? 'emoji-active' : ''" @click="changeEmojiCategory(index)" v-for="(item, index) in emojiCates" :key="index">
                  {{ item }}
                </div>
              </div>
              <div v-for="(emojiGroup, category, index) in emojis" :key="category">
                <div class="emoji-item" v-if="emojiCategory == index">
                  <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
                </div>
              </div>
            </div>
          </emoji-picker>
          <el-upload
            :multiple="false"
            :before-upload="beforeUpload"
            :http-request="handleUpload"
            class="upload-demo"
            :show-file-list="false"
            :auto-upload="true"
            :action="'/asd'"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            v-loading="isUpLoading"
          >
            <img class="icon-img" style="width: 0.25rem; height: 0.25rem" src="./img/picture.png" alt />
          </el-upload>
        </div>
        <div class="btn" @click="sendMsg">发送</div>
      </div>
    </div>
    <div class="group-info-wrap" v-show="isGroupInfo || isGroupMembers">
      <GroupInfo v-if="isGroupInfo" @closeGroupInfo="closeGroupInfo" @toGroupMembers="toGroupMembers" @changeGroupInfo="changeGroupInfo" :isHeaderShow="false" />
      <GroupMembers v-if="isGroupMembers" @changeGroupMembers="changeGroupMembers" @toUserChat="toUserChat" />
    </div>
    <ConfirmDialogUserCenter :content="content" @confirmDialog="confirmDialog" ref="confirmDialog" />
    <BannedDialog :bannedUserVal="bannedUserVal" ref="bannedDialog" />
    <SendPicture :sendPicture="sendPicture" :isLoadingPic="isLoadingPic" @clearPicture="clearPicture" @confirmDialog="confirmDialog" ref="sendPicture" />
  </div>
</template>

<script>
import { post } from "@/util/http";
import { mapState, mapMutations, mapActions } from "vuex";
import { format } from "@/util/time";
import TIM from "tim-js-sdk";
import { tim } from "@/util/tim";
import ConfirmDialogUserCenter from "@/components/dialog/ConfirmDialogUserCenter";
import BannedDialog from "@/components/dialog/BannedDialog";
import GroupInfo from "@/components/group-info/group-info";
import GroupMembers from "@/components/group-members/group-members";
import { EmojiPicker } from "vue-emoji-picker";
import uploadByCosSdk from "@/mixins/uploadByCosSdk";
import SendPicture from "@/components/dialog/SendPicture";

export default {
  mixins: [uploadByCosSdk],
  components: {
    ConfirmDialogUserCenter,
    BannedDialog,
    GroupInfo,
    GroupMembers,
    EmojiPicker,
    SendPicture,
  },
  data() {
    return {
      emojiCates: ["常用", "笑脸", "动物", "物品"],
      emojiCategory: 0,
      messageContent: "",
      visible: false,
      chatInfo: {},
      errorMessageIds: [],
      errorMsg: "",
      deleteMsgId: 0,
      content: "",
      kickoutDialog: ["确定要踢出群聊吗？"],
      unbannedDialog: ["确定要解除禁言吗？"],
      deleteMsgDialog: ["确定要删除消息吗？"],
      withdrawDialog: ["确定要撤回消息吗？"],
      bannedUser: 0,
      bannedUserVal: {},
      unbannedUser: 0,
      withdrawMsgId: 0,
      showMoreMsg: false,
      isBottom: true,
      isGroupInfo: false,
      isGroupMembers: false,
      watchOnce: true,
      addHeightForBanned: 0,
      page: 1,
      isUpLoading: false,
      sendPicture: "",
      isLoadingPic: false,
    };
  },
  computed: {
    ...mapState(["userInfo", "groupMessageList", "fanGroup", "groupInfo", "anchorId", "noMoreMsg", "isLoadingMore"]),
  },
  props: {},

  watch: {
    groupMessageList(newVal) {
      // let lastArray = newVal[newVal.length - 1] || {};
      if (!this.isBottom) {
        this.showMoreMsg = true;
      }
      if (this.isBottom) {
        this.toBottom();
      }
    },
    // "fanGroup.fans_group_id": {
    //   handler(newVal, oldVal) {
    //     if (!newVal) return;
    //     if (oldVal) {
    //       this.readGroupChat(oldVal);
    //     }
    //     this.showMoreMsg = false;
    //     this.isBottom = true;
    //     this.changeNoMoreMsg(false);
    //     this.getGroupHistory();
    //     this.getGroupInfo();
    //   },
    //   immediate: true,
    // },
    // anchorId: {
    //   handler(newVal) {
    //     if (!newVal) return;
    //     this.getAnchorProfile(newVal);
    //   },
    //   immediate: true,
    // },
  },
  destroyed() {
    console.log("destroyed groupChatbox", this.fanGroup.fans_group_id);
    this.readGroupChat(this.fanGroup.fans_group_id);
    this.changeGroupMessageList([]);
  },
  mounted() {
    this.changeNoMoreMsg(false);
  },
  methods: {
    ...mapMutations(["changeUserInfo", "toggleLogin", "pushToast", "changeGroupMessageList", "changeFanGroup", "changeLeaveFanGroupId", "changeNoMoreMsg"]),
    ...mapActions(["getChatList", "getGroupHistory", "getGroupInfo", "getAnchorProfile", "readGroupChat"]),
    closeGroupInfo() {
      this.isGroupInfo = false;
      this.$emit("delGroupChangeTab");
    },
    loadImage() {
      if (this.isBottom) {
        this.toBottom();
      }
    },
    clearPicture() {
      console.log(this.sendPicture, "clearPicture");
      this.sendPicture = "";
    },
    toUserChat(item) {
      this.$emit("toUserChat", item);
    },
    handleUpload(res) {
      const file = res.file;
      console.log("handleUpload", file);
      this.$refs.sendPicture.open();
      this.isLoadingPic = true;
      this.upload(file)
        .then((res) => {
          if (res.status === 0) {
            console.log("handleUpload", res);
            this.sendPicture = res.data;
            this.isLoadingPic = false;
          }
        })
        .finally((err) => {
          console.log(err);
        });
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpg";
      const isGIF = file.type === "image/gif";
      const isPNG = file.type === "image/png";
      const isJpeg = file.type === "image/jpeg";
      if (!isJPG && !isGIF && !isPNG && !isJpeg) {
        this.$message.error("发送图片必须是JPG/GIF/PNG 格式!");
        return false;
      }
    },
    changeEmojiCategory(category) {
      this.emojiCategory = category;
    },
    insert(emoji) {
      this.messageContent += emoji;
    },
    // 换行
    lineFeed() {
      console.log("换行");
      console.log(this.messageContent);
      this.messageContent = this.messageContent + "\n";
    },

    changeGroupInfo() {
      this.isGroupInfo = false;
    },
    toGroupInfo() {
      this.isGroupInfo = true;
    },

    changeGroupMembers() {
      this.isGroupMembers = false;
      this.isGroupInfo = true;
    },
    toGroupMembers() {
      this.isGroupMembers = true;
      this.isGroupInfo = false;
    },
    setting() {
      if (this.isGroupInfo || this.isGroupMembers) {
        this.isGroupInfo = false;
        this.isGroupMembers = false;
      } else {
        this.isGroupInfo = true;
      }
    },
    openConfirmWithdrawPopup(val, item) {
      this.content = val;
      this.withdrawMsgId = 0;
      this.bannedUserVal = item;
      this.$refs.confirmDialog.open();
    },
    openWithdraw(index) {
      this.withdrawMsgId = index;
    },
    openConfirmUnbannedPopup(val) {
      this.content = val;
      this.bannedUser = 0;
      this.$refs.confirmDialog.open();
    },
    openConfirmBannedPopup() {
      this.bannedUser = 0;
      this.$refs.bannedDialog.open();
    },
    openConfirmKickoutPopup(val) {
      this.content = val;
      this.bannedUser = 0;
      this.$refs.confirmDialog.open();
    },
    openBannedUserPopup(val, index) {
      let avatarToTop = this.$refs.avatar[index].offsetTop;
      console.error(index, avatarToTop, "openBannedUserPopup");
      if (avatarToTop < 140) {
        this.addHeightForBanned = (140 - avatarToTop) / 100 + "rem";
      }
      if (val.role === 2) {
        this.$emit("openAnchorInfo", val.uid);
        return;
      }
      if (this.groupInfo.user_info.role === 1 && val.role === 0) {
        console.log("bannedUserVal", val);
        this.bannedUserVal = val;
        this.getBanInfo(val);
      }
    },
    openConfirmDeleteMsgPopup(val, item) {
      if (this.groupInfo.user_info.role > 0) {
        this.bannedUserVal = item;
        console.log(this.bannedUserVal);
        this.content = val;
        this.deleteMsgId = 0;
        this.$refs.confirmDialog.open();
      }
    },
    openDeleteMsgPopup(val) {
      if (this.groupInfo.user_info.role > 0) {
        this.deleteMsgId = val;
      }
    },
    closeDeleteMsgPopup() {
      this.deleteMsgId = 0;
      this.bannedUser = 0;
      this.withdrawMsgId = 0;
      this.unbannedUser = 0;
      this.addHeightForBanned = 0;
      this.isGroupInfo = false;
      this.isGroupMembers = false;
    },
    confirmDialog(val) {
      if (val === this.deleteMsgDialog) {
        console.log(val);
        this.delMsg();
      } else if (val === this.unbannedDialog) {
        console.log(val);
        this.cancelBanUser();
      } else if (val === this.withdrawDialog) {
        console.log(val);
        this.revokeMsg();
      } else if (val === this.kickoutDialog) {
        console.log(val);
        this.kickUser();
      } else if (val === this.sendPicture) {
        this.sendMsg();
      }
    },

    withdrawMsg(seq) {
      let arr = this.groupMessageList.filter((e) => e.seq !== seq);
      let notice = {
        chatType: 3,
        content: "您已撤回一条消息",
      };
      this.changeGroupMessageList([...arr, notice]);
    },
    kickUser() {
      post({
        url: "/api/groupChat/kickUser",
        data: { group_id: this.groupInfo.id, kick_user_ids: [this.bannedUserVal.uid] },
      })
        .then(({ data: { msg } }) => {
          if (msg === "SUCCESS") {
            this.$message.success("踢出群聊成功");
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    revokeMsg() {
      if (this.errorMessageIds.indexOf(this.bannedUserVal.send_time) > -1) {
        this.$message.error("消息未发送成功");
        return;
      }
      post({
        url: "/api/groupChat/revokeMsg",
        data: { group_id: this.groupInfo.id, msg_id: this.bannedUserVal.seq },
      })
        .then(({ data: { msg } }) => {
          if (msg === "SUCCESS") {
            this.withdrawMsg(this.bannedUserVal.seq);
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    delMsg() {
      post({
        url: "/api/groupChat/delMsg",
        data: { group_id: this.groupInfo.id, msg_id: this.bannedUserVal.seq },
      })
        .then(({ data: { msg } }) => {
          console.log(msg);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    cancelBanUser() {
      post({
        url: "/api/groupChat/cancelBanUser",
        data: { ban_user_id: this.bannedUserVal.uid, fans_group_id: this.bannedUserVal.group_id },
      })
        .then(({ data: { msg } }) => {
          if (msg === "SUCCESS") {
            this.unbannedUser = 0;
            this.$message.success("解除禁言成功");
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    getBanInfo(user) {
      post({
        url: "/api/groupChat/getBanInfo",
        data: { ban_user_id: user.uid, fans_group_id: user.group_id },
      })
        .then(({ data: { data } }) => {
          console.log(data.is_ban, "data.is_ban");
          this.bannedUserVal.level = data.user_level;
          if (!data.is_ban) {
            this.bannedUser = user.send_time;
          } else {
            this.unbannedUser = user.send_time;
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    formatMessage() {
      if (this.messageContent.length > 200 && this.groupInfo.user_info.role !== 1) {
        this.messageContent = this.messageContent.slice(0, 200);
        this.$message.error("已达到数字上限");
      }
    },
    sendMsg() {
      if (!this.messageContent.trim() && this.sendPicture === "") {
        this.messageContent = "";
        this.pushToast("输入不能为空");
        return;
      }
      // 发送消息
      const msg = {
        type: "say",
        groupId: this.fanGroup.fans_group_id,
        content: window.encrypt(this.messageContent.trim()), //接口提供wasm加密
        image_url: this.sendPicture,
      };

      console.log("groupMessageList:::::::::", this.groupMessageList);
      let nowTime = Date.parse(new Date());
      let lastMsgTime = this.groupMessageList[this.groupMessageList.length - 1]?.send_time || 0;
      console.log(nowTime, lastMsgTime, "time");
      //相隔60秒添加时间线
      if (nowTime - lastMsgTime > 60000) {
        this.groupMessageList.push({
          chatType: 3,
          send_time: nowTime,
          content: format(nowTime, "MM-dd hh:mm"),
        });
      }
      this.groupMessageList.push({
        chatType: 1,
        send_time: nowTime,
        content: this.messageContent.trim(),
        image_url: this.sendPicture,
        uid: this.userInfo.id,
      });
      this.timSend(msg, nowTime);
      this.messageContent = "";
      this.sendPicture = "";

      console.log(msg, this.groupMessageList, "msg");
      this.toBottom();
    },
    timSend(msg, nowTime) {
      let msgJson = JSON.stringify(msg);
      let message = tim.createCustomMessage({
        to: this.fanGroup.fans_group_id,
        conversationType: TIM.TYPES.CONV_GROUP,
        payload: {
          data: msgJson,
        },
      });
      console.log("message=======================", message);
      let msgLength = this.groupMessageList.length;
      let promise = tim.sendMessage(message);
      promise
        .then((imResponse) => {
          // 发送成功
          // this.toBottom();
          console.log("发送成功", imResponse);
          this.groupMessageList[msgLength - 1].seq = message.sequence; //临时直接修改vuex
        })
        .catch((imError) => {
          // 发送失败
          this.errorMessageIds.push(nowTime);
          this.errorMsg = imError.message;
          if (imError.code === 10007) {
            this.errorMsg = "您已不在群聊，不能发言";
            this.$message.error("您已不在群聊，不能发言");
            return;
          } else if (imError.code === 10017) {
            this.errorMsg = "您已被禁言";
            this.$message.error("您已被禁言");
            return;
          } else {
            this.$message.error(imError.message);
          }
        });
    },
    onscroll() {
      // 是否滚动到了底部
      let chatBox = this.$refs.privateChat;
      let clientHeight = chatBox?.clientHeight;
      let scrollTop = chatBox?.scrollTop;
      let scrollHeight = chatBox?.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.showMoreMsg = false;
        this.isBottom = true;
      } else {
        this.isBottom = false;
      }
      if (scrollTop === 0) {
        console.log("toTop");
        this.page++;
        if (!this.noMoreMsg) {
          this.getGroupHistory(this.page);
        }
      }
    },
    toBottom() {
      this.$nextTick(() => {
        if (this.$refs["privateChat"]) {
          this.$refs["privateChat"].scrollTop = this.$refs["privateChat"].scrollHeight;
        }
      });
    },
    showErrorMsg() {
      this.$message.error(this.errorMsg);
    },
  },
};
</script>
<style lang="scss" scoped>
.chat-box {
  width: 6rem;
  display: flex;
  flex-direction: column;
  position: relative;
  .group-info-wrap {
    position: absolute;
    right: 0;
    top: 0.52rem;
    width: 3.4rem;
    height: 8.28rem;
    .group-info {
      margin: 0;
      height: 8.28rem;
    }
    .group-members {
      margin: 0;
      height: 8.28rem;
    }
    .anchor-info {
      margin: 0;
      height: 8.28rem;
    }
  }
  .chat-box-header {
    padding: 0.16rem;
    height: 0.52rem;
    background: #f4f4f4;
    box-shadow: inset 0px -0.5px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      font-weight: 500;
      font-size: 0.16rem;
    }
    .right {
      width: 0.24rem;
      cursor: pointer;
    }
  }

  .private-content {
    flex: 1;
    padding: 0.08rem 0.12rem;
    overflow-y: auto;
    .chat-time {
      text-align: center;
      margin-bottom: 0.12rem;
      color: #999;
      font-size: 0.12rem;
    }
    .chat-anchor {
      display: flex;
      align-items: flex-end;
      line-height: 0.2rem;
      margin-bottom: 0.16rem;
      position: relative;
      .avatar {
        position: relative;
        img {
          width: 0.28rem;
          height: 0.28rem;
          border-radius: 0.28rem;
          margin-right: 0.08rem;
          cursor: pointer;
        }
        .popup-banned {
          z-index: 1;
          width: 1rem;
          height: 0.9rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;
          position: absolute;
          left: 0;
          top: -1.06rem;
          background: #ffffff;
          box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);
          border-radius: 0.05rem;
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.08rem solid transparent;
            border-top-color: #ffffff;
            left: 0.17rem;
            bottom: -0.15rem;
          }
          .bar {
            width: 0.8rem;
            height: 0.5px;
            background: #f4f4f4;
          }

          .banned {
            cursor: pointer;
            width: 100%;
            text-align: center;
          }
        }
        .unbanned {
          height: 0.45rem;
          top: -0.39rem;
        }
      }
      .msg {
        max-width: 2.84rem;
        padding: 0.05rem 0.12rem;
        background: #f4f4f4;
        border-radius: 0.1rem 0.1rem 0.1rem 0px;
        position: relative;
        cursor: pointer;
        .popup {
          width: 0.48rem;
          height: 0.44rem;
          line-height: 0.44rem;
          text-align: center;
          position: absolute;
          left: 0;
          top: -0.53rem;
          background: #ffffff;
          box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);
          border-radius: 0.05rem;
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.08rem solid transparent;
            border-top-color: #ffffff;
            left: 0.17rem;
            bottom: -0.15rem;
          }
        }

        .nickname {
          color: #8393bc;
          display: flex;
          align-items: center;
          .role {
            width: 0.39rem;
            height: 0.2rem;
            line-height: 0.18rem;
            text-align: center;
            background: rgba(2, 161, 249, 0.2);
            border: 1px solid rgba(60, 156, 254, 0.5);
            border-radius: 0.02rem;
            color: #02a1f9;
            font-size: 0.12rem;
            transform: scale(0.83);
          }
          .role1 {
            background: rgba(2, 168, 162, 0.2);
            border: 1px solid rgba(2, 168, 162, 0.5);
            color: #02a8a2;
          }
        }
        .angle {
          width: 0.07rem;
          position: absolute;
          left: -0.07rem;
          bottom: 0;
        }
        .text {
          word-break: break-word;
          white-space: pre-wrap;
          cursor: pointer;
        }
      }
    }
    .chat-user {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      line-height: 0.2rem;
      margin-bottom: 0.16rem;

      .msg {
        max-width: 2.84rem;
        padding: 0.05rem 0.12rem;
        background: rgba(2, 168, 162, 0.2);
        border-radius: 0.1rem 0.1rem 0px 0.1rem;
        position: relative;
        cursor: pointer;
        .withdraw {
          width: 0.48rem;
          height: 0.44rem;
          line-height: 0.44rem;
          text-align: center;
          position: absolute;
          right: 0;
          top: -0.53rem;
          background: #ffffff;
          box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.05);
          border-radius: 0.05rem;
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.08rem solid transparent;
            border-top-color: #ffffff;
            left: 0.17rem;
            bottom: -0.15rem;
          }
        }
        .red-dot {
          position: absolute;
          top: 0.08rem;
          left: -0.2rem;
          background: #db6372;
          width: 0.16rem;
          height: 0.16rem;
          border-radius: 0.16rem;
          line-height: 0.16rem;
          text-align: center;
          color: #ffffff;
          margin-right: 0.04rem;
          cursor: pointer;
        }
        .angle {
          width: 0.07rem;
          position: absolute;
          right: -0.07rem;
          bottom: 0;
        }
        .text {
          word-break: break-word;
          white-space: pre-wrap;
        }
      }
      .avatar {
        width: 0.28rem;
        height: 0.28rem;
        border-radius: 0.28rem;
        margin-left: 0.08rem;
      }
    }
  }

  .to_bottom_btn {
    margin: 0 auto;
    width: 2.2rem;
    height: 0.3rem;
    background: rgba(2, 168, 162, 0.7);
    text-align: center;
    line-height: 0.3rem;
    color: #fff;
    font-size: 0.12rem;
    position: relative;
    cursor: pointer;
    &::before {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      // top: 60%;
      bottom: 0;
      left: 26%;
      transform: translateY(-50%);
      border: 0.05rem solid transparent;
      border-top: 0.05rem solid #fff;
    }
  }
  .chat-box-message {
    height: 1.5rem;
    background: #f4f4f4;
    box-shadow: inset 0px 0.5px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    textarea {
      width: 100%;
      border: none;
      background: #f4f4f4;
      color: #333333;
      padding: 0.12rem;
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 0.65rem;
      background: #f9f9fb;
      padding: 0 0.12rem;
      .plugs {
        display: flex;
        align-items: center;
        img {
          width: 0.3rem;
          margin-right: 0.05rem;
          cursor: pointer;
        }
        .emoji {
          width: 3.39rem;
          position: absolute;
          top: -1.6rem;
          left: 0;
          background-color: #fff;
          border-top: 0.01rem solid #eee;
        }
        .emoji-cats {
          display: flex;
          .emoji-cat {
            width: 0.85rem;
            height: 0.3rem;
            background-color: #eee;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
          .emoji-active {
            background-color: #fff;
          }
        }
        .emoji-item {
          height: 1.3rem;
          padding: 0.1rem;
          overflow: scroll;
          span {
            margin: 0.03rem;
            margin-bottom: 0.05rem;
            display: inline-block;
            cursor: pointer;
          }
        }
      }
      .btn {
        width: 1rem;
        height: 0.42rem;
        background: #02a8a2;
        border-radius: 0.05rem;
        font-size: 0.16rem;
        color: #ffffff;
        text-align: center;
        line-height: 0.42rem;
        cursor: pointer;
      }
    }
  }
}
</style>
